<template>
  <div>
    <v-simple-table dense v-if="isSubunitsPresent">
      <template v-slot:default>
        <tbody v-for="(item, key) in achievementUnits" :key="item.id">
        <tr>
          <td :rowspan="item.subunits.length + 2">{{ item.name }}</td>
        </tr>
        <tr>
          <th colspan="1" class="text-left">
            №
          </th>
          <th class="text-left">
            Название
          </th>
          <th class="text-right">
            Баллы
          </th>
        </tr>
        <tr v-for="(item, key) in item.subunits" :key="item.id">
          <td colspan="1">{{ key + 1 }}</td>
          <td>{{ item.name }}</td>
          <td class="text-right">{{ item.score }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>

    <v-simple-table dense v-else>
      <template v-slot:default>
        <thead>
        <tr>
          <th colspan="1" class="text-left">
            №
          </th>
          <th class="text-left">
            Название
          </th>
          <th class="text-right">
            Баллы
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in achievementUnits" :key="item.id">
          <td colspan="1">{{ key + 1 }}</td>
          <td>{{ item.name }}</td>
          <td class="text-right">{{ item.score }}</td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </div>
</template>

<script>
export default {
  name: "UnitsTableCard",

  props: {
    units_achievement: {
      Type: Array,
      required: true,
    }
  },

  computed: {

    achievementUnits() {return this.units_achievement?.units || this.units_achievement?.levels || null},

    isSubunitsPresent() {return this.achievementUnits[0]?.subunits?.length > 0 || false },
  },

}
</script>

<style scoped>

</style>